'use client'

import Link from 'next/link'
import { ProductCard } from '@/components/products/ProductCard'
import { useState } from 'react'
import useCartStore, { ICartItem } from '@/store/cartStore'
import useCommonStore from '@/store/commonStore'
import { toast } from '@/hooks/use-toast'
import { VariantPopup } from '../common/VariantPopup'
import { GTMAddToCartHandler, GTMRemoveFromCartHandler } from '@/lib/analytics'


interface IObj {
  [key: string]: any
}
interface IProduct {
  pdt_nm: string
  price: string
  currency: string
  spl_prc: string
  spl_prc_in_num: number
  disc: string
  disc_typ: string
  slug: string
  thumbnail: string
  rating: number
  pdt_id: string
  path: string
  max_order_quantity: number
  variants: IObj[]
  total_sold: number
  in_stk: boolean

}
interface IBestSellerProps {
  props: {
    list: IProduct[]
    [key: string]: any
  }
}

export function BestSellers({ props }: IBestSellerProps) {
  const [variants, setVariants] = useState<IObj[]>([])
  const [mxq, setMxq] = useState<number>(-1)
  const { updateCart } = useCartStore()
  const { isAuth, translations } = useCommonStore()

  const cartHandler = async (item: ICartItem, mxq?: number, type?: string, spl_prc?: number, pdt_nm?: string) => {
    if (type === "increment") {
      GTMAddToCartHandler({
        value: spl_prc,
        items: [
          {
            item_id: item.pdt_id,
            item_variant: item.variant_id,
            quantity: item.quantity,
            price: spl_prc,
            item_name: pdt_nm ? pdt_nm : "",

          }]
      })
    }
    else if (type === "decrease") {
      GTMRemoveFromCartHandler({
        value: spl_prc,
        items: [
          {
            item_id: item.pdt_id,
            item_variant: item.variant_id,
            quantity: item.quantity,
            price: spl_prc,
            item_name: pdt_nm ? pdt_nm : "",

          }]
      })
    }

    const update = await updateCart(item, mxq ?? -1, isAuth);
    if (update?.status) {
      toast({ variant: "default", title: "Cart updated", description: update?.message });
      setModalOpen(false)
    } else {
      toast({ variant: "destructive", title: update?.message, description: update?.error });
    }
  };
  const [modalOpen, setModalOpen] = useState(false)
  const onClose = () => {
    setVariants([])
    setMxq(-1)
    setModalOpen(false)
  }
  const handleAddToCart = (max_order_quantity: number, product?: ICartItem | null, list?: IObj[], type?: string, spl_prc?: number, pdt_nm?: string) => {
    if (list && list.length > 0) {
      setMxq(max_order_quantity)
      setVariants(list)
      setModalOpen(true)
      return
    } else if (product) {
      cartHandler(product, max_order_quantity, type, spl_prc, pdt_nm)
    }
  }

  return (
    <section
      className="py-4 md:py-20 bg-[linear-gradient(244.49deg,_#EAEAFF_-0.68%,_#FFF3EF_95.44%)]"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between px-4 md:px-0 mb-3 md:mb-5 relative">
          {/* Desktop: Center title, right-aligned View all */}
          <h2 className="text-lg md:text-2xl font-bold flex-1">
            {props.title}
          </h2>
          {
            props.view_all && (
              <>
                <Link
                  href={props.view_all}
                  className="text-sm text-gray-500"
                >
                  {translations?.view_all || 'View All'}
                </Link>
              </>
            )
          }
        </div>

        {/* Products */}
        <div className="flex md:justify-start overflow-x-auto gap-4 md:gap-8 px-4 md:px-0 scrollbar-hide">
          {props?.list?.map((product: IProduct) => (
            <ProductCard
              key={product.pdt_id}
              product={product}
              variant="carousel"
              onAddToCart={handleAddToCart}
            />
          ))}
        </div>
      </div>
      {
        modalOpen && variants?.length && (
          <VariantPopup open={modalOpen} onClose={onClose} variants={variants || []} mxq={mxq} handler={cartHandler} />
        )
      }
    </section>
  )
}